import { apiClient } from "./client";

async function post(url, body) {
  const res = await apiClient.post(url, body);
  return res.data;
}

export const getChannelCommissions = (id) => post("/dash/channel-commissions/list", { id });
export const saveChannelCommission = (id, channelName, commissionPercent) =>
  post("/dash/channel-commissions/upsert", { id, channelName, commissionPercent });
export const removeChannelCommission = (id, channelName) =>
  post("/dash/channel-commissions/remove", { id, channelName });
